import { GamePass } from "../GamePass";
import { Image } from "../Image";
import { Offer } from "../Offer";
import { MockOffer } from "./MockOffer";

export class MockGamePass implements GamePass {
  private static INDEX = 0;

  public uuid: string;
  public images: Image[];
  public name: string;
  public offer: Offer;
  public pre_subscription: { description: string; title: string };
  public post_subscription: { description: string; title: string };

  constructor() {
    MockGamePass.INDEX++;
    this.uuid = `${MockGamePass.INDEX}`;
    this.images = [];
    this.name = `GamePass ${MockGamePass.INDEX}`;
    this.offer = new MockOffer();
    this.pre_subscription = {
      description: `GamePass description ${MockGamePass.INDEX}`,
      title: `GamePass title ${MockGamePass.INDEX}`,
    };
    this.post_subscription = {
      description: `GamePass post sub description ${MockGamePass.INDEX}`,
      title: `GamePass post sub title ${MockGamePass.INDEX}`,
    };
  }
}
